import React, { HtmlHTMLAttributes, PropsWithChildren } from 'react';
import styles from './FieldError.module.scss';

function FieldError({ children }: PropsWithChildren<HtmlHTMLAttributes<HTMLParagraphElement>>) {
  return <p className={styles.FieldError}>{children}</p>;
}

export default FieldError;
